'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var footer = exports.footer = {
  apps_links_title: 'Download the App',
  google_title: 'In Google Play',
  apple_title: 'In Apple Store',

  info_links_title: 'Information',

  tutellus_links_title: 'Tutellus',

  howitworks_title: 'How it works',
  certificates_title: 'Certificates',
  give_title: 'Gifts',
  subscription_title: 'Subscriptions',
  api_title: 'Affiliate API',
  channels_title: 'Channels',

  us_title: 'Our Team',
  teachers_title: 'Teachers',
  help_title: 'Help',

  contact_email_title: 'E-mail',
  contact_phone_title: 'Phone',

  copyright: '<b>&copy; 2018 Tutellus. All rights reserved </b> <a href="https://www.tutellus.com/informacion/terminos-y-condiciones" target="_blank">Read our term and conditions, and our cookie policy.</a> <a href="http://www.stackscale.es/" target="_blank">Private cloud hosting with Stackscale</a>'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/footer.js
// module id = 714
// module chunks = 0